import React from 'react';
// import '../../_assets/css/file.css';
import { Form } from "react-bootstrap";
import axios from 'axios';
import { Card, CardBody, Col, Button } from 'reactstrap';
import { baseURL } from '../../_helpers';
import { AGENTEMAIL, AGENTID, AGENTNAME, AGENTPHONE, TOKEN } from '../../_helpers/exports';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Input from 'react-phone-number-input/input'
import { Link } from 'react-router-dom';
import Alert from '../../shared/components/Alert';
import Select from 'react-select';


class Withdrawal extends React.Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
    };
    constructor(props) {
        super(props)
        this.state = {
            showComponent: false,
            hideComponent: true,
            moreinfo: false,
        };
        this._onButtonClick = this._onButtonClick.bind(this);

        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            isLoading: false,
            isShowError: false,
            statusMessage: '',
            showError: false
        }
    }

    handleChangeRegion = (event) => {
        this.setState({ customer_type: event.target.value });
    };


    handleChangeType = (event) => {
        this.setState({ title: event.target.value });
    };

    onSubmit(e) {
        e.preventDefault();


        let formData = {

            "session_id": TOKEN,
            "amount": this.state.amount
        }

        this.setState({ isLoading: true });
        axios.post(baseURL + 'initiate_withdrawal', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {
            console.log('bayoo', response.data)
            if (response.data.code === "0000") {
                this.setState({ statusMessage: response.data.message, showError: false, isShowError: true, isLoading: false });
                window.scrollTo(0, 0)
                window.setTimeout(() => {
                    this.setState({ isShowError: false });
                    this._onButtonClick();
                }, 2000);
            } else {
                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, isLoading: false });

                window.setTimeout(() => {
                    this.setState({
                        isLoading: false,
                        isShowError: false,
                        statusMessage: "",
                        showError: false
                    });
                }, 2000);
            }
        }).catch((error) => {
            console.log('bayoo', error)
            this.setState({
                statusMessage: error.response === undefined ? "Check your Internet" : error.response.data.message, showError: true, isShowError: false, isLoading: false
            });
            window.setTimeout(() => {
                this.setState({
                    isLoading: false,
                    isShowError: false,
                    showError: false,
                    errorShow: false
                });
            }, 2000);
        })
    }


    _onButtonClick() {
        this.setState({
            showComponent: true,
            hideComponent: true,
            moreinfo: false
        });
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    render() {
        const { showComponent } = this.state;
        const { hideComponent } = this.state;

        return (
            <div>

                {!hideComponent && (
                    <>
                        <Col md={12} lg={12}>
                            <Card>
                                <CardBody>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h4><b>Withdrawal</b></h4><br />
                                        </div>

                                    </div>


                                    {this.state.showError ? <div >

                                        <Alert color="danger" className="alert--colored" icon>
                                            <p><span className="bold-text">{this.state.statusMessage}</span>
                                            </p>
                                        </Alert>
                                    </div> : null}

                                    {this.state.isShowError ? (
                                        <div>
                                            <Alert color="success" className="alert--colored" icon>
                                                <p><span className="bold-text">{this.state.statusMessage}</span>
                                                </p>
                                            </Alert>
                                        </div>
                                    ) : null}<br></br>
                                    <form className="form" className="col-8 offset-2" onSubmit={this.onSubmit}>
                                        <div className="col-md-12">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <div className="row">
                                                        <label className="form-label">Amount</label>
                                                        <input id="input" type="number" className="form-control"
                                                            name="amount" placeholder='Amount'
                                                            value={this.state.amount} onChange={this.handleChange} />
                                                    </div>
                                                </div>
                                                <br />
                                            </div>

                                            <Button type="submit" color="primary" outline className="btn-paypal float-right btn-lg" >
                                                {this.state.isLoading ? "Please Wait..." : "Send"}
                                            </Button> &nbsp;&nbsp;&nbsp;
                                        </div>



                                    </form>
                                </CardBody>
                            </Card>
                        </Col >
                    </>
                )
                }
            </div>
        )
    }
}
export default withTranslation('common')(Withdrawal);
